import { Observable, ApolloLink } from "@apollo/client";
import jwtDecode from "jwt-decode";
// import { dispatch } from "../../redux";

import graphqlRequest from "./graphqlRequest";
// import logout from "../../redux/actions/logout";

const query = `mutation ($refreshToken: String!, $clientId: String!) {
  refreshTokens(input: { refreshToken: $refreshToken, client: { clientId: $clientId } }) {
    tokens {
      accessToken
      refreshToken {
        refreshToken
      }
    }
  }
}`;

const clientId = CLIENT_ID; // eslint-disable-line no-undef

function logout() {
  window.localStorage.removeItem("refreshToken");
  window.localStorage.removeItem("accessToken");
  window.localStorage.removeItem("tokenExpires");
  window.history.pushState({}, "", "/");
}

export async function refreshTokens(refreshToken) {
  const token = refreshToken || window.localStorage.getItem("refreshToken");

  if (!token) {
    console.warn("No token found, logging out");
    logout();
    return;
  }

  const { data, errors } = await graphqlRequest({
    query,
    variables: {
      clientId,
      refreshToken: token,
    },
  });

  if (!data) {
    console.error(errors);
    logout();

    return;
  }

  // Set the expiration for the new token
  const { exp } = jwtDecode(data.refreshTokens.tokens.accessToken);
  window.localStorage.setItem("tokenExpires", exp.toString());
  window.localStorage.setItem(
    "accessToken",
    data.refreshTokens.tokens.accessToken
  );
  window.localStorage.setItem(
    "refreshToken",
    data.refreshTokens.tokens.refreshToken.refreshToken
  );

  return data;
}

export async function isExpiredElseFetchToken() {
  const expiration = parseInt(localStorage.getItem("tokenExpires"), 10);

  if (!expiration) return;

  const now = Date.now() / 1000;

  let token = "";

  // The token will expire within the next 5 seconds
  if (expiration - now < 5) {
    const data = await refreshTokens();
    token = data.refreshTokens.tokens.accessToken;
  }

  if (!token) token = window.localStorage.getItem("accessToken");

  return token;
}

async function request(operation) {
  if (typeof window === "undefined") return;

  const accessToken = await isExpiredElseFetchToken();

  if (accessToken) {
    operation.setContext({
      headers: {
        authorization: accessToken,
      },
    });
  }
}

export default new ApolloLink(
  (operation, forward) =>
    new Observable((observer) => {
      let handle;
      Promise.resolve(operation)
        .then((oper) => request(oper))
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer),
          });
        })
        .catch(observer.error.bind(observer));

      return () => {
        if (handle) {
          handle.unsubscribe();
        }
      };
    })
);
